import { Typography } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import { NonEmptyList } from 'nonempty-list';
import { findLinkBy } from '../../../../Links';
import DateTime from '../../Shared/DateTime';
import ImageComponent from '../../Shared/ImageComponent';
import { RecentlyLoggedInResource } from './Decoder';

interface Props {
  recentlyLoggedInResource: NonEmptyList<RecentlyLoggedInResource>;
}

function Row({ recentlyLoggedInResource }: Props) {
  return recentlyLoggedInResource.map((recentlyLoggedInValue) => (
    <div key={recentlyLoggedInValue.payload.id} className="flex justify-between mt-4">
      <div className="flex items-center w-full">
        <ImageComponent
          size="xs"
          imgLink={findLinkBy({ rel: 'avatar' }, recentlyLoggedInValue.links)}
          altText={`Avatar for ${recentlyLoggedInValue.payload.name}`}
        />
        <div className="w-full flex">
          <Typography as="div" variant="bodyMedium" className="w-[50%]" color="dark">
            {recentlyLoggedInValue.payload.name}
          </Typography>
          <DateTime position="text-end" dateTime={recentlyLoggedInValue.payload.currentSignInAt} />
        </div>
      </div>
    </div>
  ));
}

export default observer(Row);
